import React from 'react';
import { JumbotronTypes } from '../../jumbotronTypes';
import { CardDetailsLocation } from './CardDetailsLocation';
import { CardListOfCard } from './CardListOfCard';
import { CardDropdown } from './CardDropdown';

export const CardSection = ({
  textOverlay,
  contactDetails,
  cardDropDown,
  variant,
  accordion,
}: JumbotronTypes.ICard) => {
  const renderCard = () => {
    switch (variant) {
      case 'multiLocationListOfCard':
        return (
          <CardListOfCard
            contactDetails={contactDetails}
            textOverlay={textOverlay}
            variant={variant}
            accordion={accordion}
          />
        );
      case 'multiLocationDropDown':
        return (
          <CardDropdown
            contactDetails={contactDetails}
            cardDropDown={cardDropDown}
            variant={variant}
            accordion={accordion}
          />
        );
      default:
        return (
          <CardDetailsLocation
            contactDetails={contactDetails}
            textOverlay={textOverlay}
            variant={variant}
            accordion={accordion}
          />
        );
    }
  };

  return renderCard();
};
